import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import { Observable } from 'rxjs/Observable';
import {map, tap, catchError, filter, take, timeout, mergeMap} from 'rxjs/operators';
import {interval} from "rxjs/observable/interval";
import {of} from "rxjs/observable/of";
import {NotificationService} from "../../common/services/notification/notification.service";
@Injectable()
export class GeneralService extends ServiceProvider {

  protected url = '';

  constructor(
  ) {
    super(
      AppInjector.get(HttpClient),
      AppInjector.get(ApiUrl),
      ''
    );
  }

  asyncStatus(id, speed, fn): Observable<any> {
    return this.basicAsync(this.http.get(this.apiUrl.getApiUrl('/api/v1/async') + '/' + id), speed, fn);
  }

  basicAsync(req, speed= 2000, fn = null): Observable<any> {
    return interval(speed).pipe(
      mergeMap(() => req),
      tap(s => {
        if (fn) {
          fn(s);
        }
      }),
      filter(s => (((s as any).data) as any).status === 'COMPLETED' || (((s as any).data) as any).status === 'CANCELLED'),
      take(1),
      map(s => (((s as any).data) as any).code),
      timeout(60000),
      catchError(error => of(`Time out`))
    );
  }
}

